module.exports = __webpack_public_path__ + "img/soluble.5ce052bc.png";